import React from 'react';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import { Button, Grid, Icon } from '@mui/material';
import MalePlaceholder from 'assets/avatar_man.png';

export interface IPropsSimpleReactCropper {
    aspectRatio: number;
    width?: number;
    height?: number;
    fillColor?: string;
    upload: (file: Blob) => void;
    afterCrop?: () => void;
    containerStyle?: React.CSSProperties;
    handleClose: () => void;
}

class SimpleReactCropper extends React.Component<IPropsSimpleReactCropper, { src: any }> {
    private cropper: any;
    private img: any;

    state = {
        src: localStorage.getItem('profilePicture') ?? MalePlaceholder
    };

    componentDidMount() {
        this.cropper = new Cropper(this.img, {
            viewMode: 1,
            aspectRatio: this.props.aspectRatio,
            zoomable: false
        });
    }

    _uploadToServer = () => {
        if (this.cropper.getCroppedCanvas()) {
            this.cropper
                .getCroppedCanvas({
                    width: this.props.width || 500,
                    height: this.props.height || 500,
                    minWidth: 0,
                    minHeight: 0,
                    maxWidth: 1024,
                    maxHeight: 1024,
                    fillColor: this.props.fillColor || '#fff',
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: 'high'
                })
                .toBlob((blob: Blob) => {
                    this.props.upload(blob);
                });
        } else {
            this.props.handleClose()
        }
        if (this.props.afterCrop) this.props.afterCrop();
    };

    _deleteImage = () => {
        localStorage.removeItem('profilePicture')
        if (this.props.afterCrop) {
            this.props.afterCrop()
        }
        this.props.handleClose()
    }

    _handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const {
            target: { validity, files }
        } = e;

        if (validity.valid && files) {
            const reader = new FileReader();
            reader.onload = () => {
                this.setState({ src: reader.result });
                this.cropper.reset().clear().replace(reader.result);
            };
            reader.readAsDataURL(files[0]);
        }
    };

    render() {
        return (
            <div className="container_simple-react-cropper" style={{ overflow: 'hidden' }}>
                <div className="container-img_simple-react-cropper" style={this.props.containerStyle}>
                    <img ref={(node) => (this.img = node)} alt="Avatar" id="avatar_img" src={this.state.src} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingTop: '1rem',
                        backgroundColor: 'white',
                        position: 'relative',
                        zIndex: 2
                    }}
                >
                    <Grid style={{ padding: 12 }} container direction={'row'} alignItems={'flex-end'} justifyContent={'flex-end'} spacing={1}>
                        <Grid item>
                            <Button size='small' endIcon={<Icon>clear</Icon>} onClick={this.props.handleClose}>
                                Abbrechen
                            </Button>
                        </Grid>
                        {
                            localStorage.getItem('profilePicture')
                                ? <Grid item>
                                    <Button size='small' variant="outlined" component="label" color={'warning'} onClick={this._deleteImage}>
                                        Bild löschen
                                    </Button>
                                </Grid>
                                : null
                        }
                        <Grid item>
                            <Button size='small' variant="outlined" component="label" color={'primary'}>
                                Bild importieren
                                <input type="file" id="origin-image" name="origin-image" style={{ display: 'none' }} onChange={this._handleFileChange} />
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button size='small' variant={'contained'} color={'primary'} onClick={this._uploadToServer}>
                                Speichern
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default SimpleReactCropper;
